module.exports = __webpack_public_path__ + "static/media/20.04e2b829.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/20.png
// module id = 1351
// module chunks = 0